import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';
import { createRESTContract } from '../../index';
import {
  EmailStudioSettingsResponseSchema,
  EmailStudioSettingsSchema,
} from './email-reply.schema';

export const emailReplyContract = createRESTContract({
  getSettings: {
    method: 'GET',
    path: '/email-studio/settings',
    permissions: [PERMISSIONS.EMAIL_STUDIO.EMAIL_STUDIO_MANAGE],
    response: EmailStudioSettingsResponseSchema,
  },
  updateSettings: {
    method: 'PATCH',
    path: '/email-studio/settings',
    permissions: [PERMISSIONS.EMAIL_STUDIO.EMAIL_STUDIO_MANAGE],
    body: EmailStudioSettingsSchema,
    response: z.void(),
  },
});
